import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isValidRedirectRoute } from '../../services/authService';

export default function RedirectIfAuthenticated({ children, to = "/library" }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  // Determine where to redirect authenticated users
  // Priority: query param > default to prop > /library
  const getRedirectTo = () => {
    const params = new URLSearchParams(location.search);
    const fromParam = params.get('from');
    
    if (fromParam && isValidRedirectRoute(fromParam)) {
      console.log('[RedirectIfAuthenticated] Using from query param:', fromParam);
      return fromParam;
    }
    
    console.log('[RedirectIfAuthenticated] Using default to:', to);
    return to;
  };

  // If authenticated and verified, redirect away from auth pages
  if (user && user.emailVerified) {
    const redirectTo = getRedirectTo();
    return <Navigate to={redirectTo} replace />;
  }

  // If authenticated but NOT verified, keep them on verify-email
  // and redirect away from /login and /register to /verify-email
  if (user && user.emailVerified === false) {
    if (location.pathname !== '/verify-email') {
      // Preserve the ?from query param when redirecting to verify-email
      const verifyPath = `/verify-email${location.search}`;
      console.log('[RedirectIfAuthenticated] Unverified user, redirecting to:', verifyPath);
      return <Navigate to={verifyPath} replace />;
    }
  }

  return children;
}
